var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#paint0_linear_1290_574)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 28H23.9465L20.3279 24.4708L19.1839 25.2265L17.6965 24.0027L14.4937 26.5399L13.8067 25.4675L10.5967 28H10L11.1475 25.7958L13.8838 20.6004L14.8373 22.014L16.2102 19.4687L17.582 20.3501L19.7047 16L22.5265 22.3924L25 28Z",
    fill: "#92D7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28H28.6578L26.2033 23.8643L25.3722 23.9562L24.005 21.17L24 21.1562L24.5424 21L25.6097 21.9797L26.9994 21.294L30 28Z",
    fill: "#92D7E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28H21.8061C21.3812 27.3009 20.4633 25.9854 19.9186 25.9388C19.3153 25.8876 17.9466 27.1844 17.2412 28H11L14.1259 25.4634L14.7938 26.5517L17.9126 24L19.3611 25.2118L20.475 24.4696L23.9988 27.9988L24 28Z",
    fill: "#008E99"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.6792L17.812 20.2553L16.398 19.3254L14.9828 22L14 20.5028L18.4022 12L20 15.6792Z",
    fill: "#E0E9ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 21.2343L25.4491 22L24.258 20.9537L23.6527 21.1179L23 19.8976L23.0126 19.8743L24.523 17L25.4491 19.5582L25.8466 18.7447L27 21.2343Z",
    fill: "#E2E3E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28 28H24.3814L22 22.4505L23.1315 20L23.6747 21.1382L23.6793 21.1452L24.9489 23.9297L25.7207 23.8525L28 28Z",
    fill: "#64B2BF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24.1831L10.1982 24.7185L9.63609 24.5308L8.79438 25L8 24.1465L8.02219 24.1179L9.63609 22L11 24.1831Z",
    fill: "#92D7E7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11 25.3441L10.0099 28H7L8.49246 24L9.05096 25.1912L9.64275 24.5149L10.038 24.7759L10.6017 24.0337L11 25.3441Z",
    fill: "#64B2BF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28H17C17.7727 27.2091 19.2731 25.9528 19.9326 26.0014C20.5292 26.0454 21.5346 27.3221 22 28Z",
    fill: "#74CCE5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1290_574",
    x1: 18,
    y1: 0,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00585F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002022"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.bc2eb005.svg";
export { ForwardRef as ReactComponent };